import careConfig from "@careConfig";
import { useTranslation } from "react-i18next";

/** Left panel of the login page: brand, tagline and three feature lines. */
export const AuthHero = () => {
  const { t } = useTranslation();
  const { mainLogo, stateLogo, customLogo, appName } = careConfig;
  const logos = [stateLogo, customLogo].filter((logo) => logo?.light);
  const points = [
    "login_hero_point_opd",
    "login_hero_point_ipd",
    "login_hero_point_billing",
  ] as const;

  return (
    <div className="login-hero order-last relative flex flex-auto flex-col justify-between p-8 text-white md:order-first md:h-full md:w-1/2 md:p-16">
      <div className="hidden min-h-14 items-center gap-6 md:flex">
        {logos.map((logo, index) => (
          <img
            key={index}
            src={logo?.light}
            className="h-14 rounded-lg"
            alt=""
          />
        ))}
      </div>
      <div className="max-w-lg">
        <img src={mainLogo?.light} className="h-14 w-auto" alt={appName} />
        <p className="mt-6 text-2xl font-semibold leading-snug md:text-3xl">
          {t("login_hero_tagline")}
        </p>
        <ul className="mt-8 space-y-3 text-base text-blue-100">
          {points.map((key) => (
            <li key={key} className="flex items-center gap-3">
              <span className="size-2 shrink-0 rounded-full bg-blue-200" />
              {t(key)}
            </li>
          ))}
        </ul>
      </div>
      <p className="text-xs text-blue-200">
        © {new Date().getFullYear()} {appName}
      </p>
    </div>
  );
};
